export const SEARCH_TYPES = {
    alias: 'alias',
    auditCampaign: 'auditProject',
    auditRecord: 'recolement',
    authority: 'authority',
    conditionReport: 'conditionReport',
    location: 'location',
    numericContainerItem: 'numericContainerItem',
    physicalAccessoryItem: 'physicalAccessoryItem',
    physicalContainerItem: 'physicalContainerItem',
    thesaurus: 'thesaurus',
    thesaurusTerm: 'ThesaurusTerm',
    physicalMuseumItem: 'physicalMuseumItem',
}